import styled from 'styled-components';
import { Icon } from 'src/components/Icons';
import {
  darkGreenPrimary,
  hexToHSLWithGradient,
  mvpGreenLogout,
  white,
} from 'src/styles/colors';
import { defaultTransition, mediaMaxWidth2 } from 'src/styles/layout';
import { secondaryHover } from 'src/styles/effects';
import { LockIcon } from '../Icons/Lock';

const verticalAlign = 'middle';
const breakpointStyles = 'line-height: 1.4em;';
const breakpointStylesButton =
  breakpointStyles +
  `
  padding: 0.1em;
  font-size: 1.4em;
  height: 40px;
  width: 40px;
  margin-right: 16px;
  border-radius: 25px;
  background: #216E53;
  transition: ${defaultTransition};
`;

export const LogoutButton = styled.button`
  padding: 0.8em 0.8em 1em 1.3em;
  background: ${({ theme }) =>
    hexToHSLWithGradient(theme.pallete.buttons.success)};
  color: ${white};
  font-weight: 700;
  line-height: 1.2em;
  font-size: 1.2em;
  display: inline-block;
  height: 54px;
  vertical-align: ${verticalAlign};
  cursor: pointer;
  border: none;

  ${mediaMaxWidth2.large`${breakpointStylesButton}`}

  &:hover,
  &:focus {
    ${secondaryHover};
    color: ${darkGreenPrimary};
    background: ${({ theme }) =>
      hexToHSLWithGradient(theme.pallete.buttons.secondary)};
  }

  &:active {
    background: rgb(34, 169, 122);
    color: ${white};
  }
`;

export const LogoutIcon = styled(Icon)`
  font-size: 1.2em;
  align-content: center;
  vertical-align: ${verticalAlign};

  ${mediaMaxWidth2.large`${breakpointStyles}`}
`;

export const MvpLogoutIcon = styled(LockIcon)`
  font-size: 1.2em;
  align-content: baseline;
  vertical-align: ${verticalAlign};

  ${mediaMaxWidth2.large`${breakpointStyles}`}

  &:hover,
  &:focus {
    ${mvpGreenLogout};
    color: ${mvpGreenLogout};
    background: ${({ theme }) =>
      hexToHSLWithGradient(theme.pallete.buttons.secondary)};
  }

  &:active {
    background: ${mvpGreenLogout};
    color: ${white};
  }
`;

export const LogoutText = styled.span`
  vertical-align: ${verticalAlign};
  font-family: 'Danske', 'Tahoma', Sans-Serif, sans-serif;

  ${mediaMaxWidth2.large`
    display: none;
  `}
`;

export const MvpLogoutButton = styled.button`
  padding: 0.1em;
  font-size: 1.4em;
  height: 40px;
  width: 40px;
  border-radius: 25px;
  background: ${mvpGreenLogout};
  transition: ${defaultTransition};
  color: ${white};
  vertical-align: ${verticalAlign};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 16px 12px 0;
  border: none;

  &:hover,
  &:focus {
    ${secondaryHover};
    color: ${mvpGreenLogout};
    background: ${({ theme }) =>
      hexToHSLWithGradient(theme.pallete.buttons.secondary)};
  }

  &:active {
    background: ${mvpGreenLogout}
    color: ${white};
  }
`;
